module.exports = __webpack_public_path__ + "446c2f876e173005a741409e3411f03d.svg";